<template>
  <BTooltip
    :label="label"
    type="is-info"
  >
    <a
      v-if="!disabled"
      class="button is-info is-rounded is-small"
    >
      <BIcon
        icon="help"
        size="is-small"
      />
    </a>
  </BTooltip>
</template>

<script>
export default {
  name: 'AppTooltip',
  props: {
    label: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
.button {
  padding-left: 0.75em!important;
  padding-right: 0.75em!important;
}

.icon {
  margin-left: calc(-0.375em - 1px)!important;
  margin-right: calc(-0.375em - 1px)!important;
  font-size: inherit!important;
}
</style>
